module.exports = __webpack_public_path__ + "img/background_10.118588c7.jpg";